import { useParams } from "react-router-dom";
import FormActions, {
  SchemaFormAction,
} from "../../components/forms/FormActionNew/FormAction";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import { useCrudAction } from "../../features/api/crud/hooks/useCrudAction";
import styles from "./PageProjectActionEdit.module.scss";
import { useMemo } from "react";
import Breadcrumbs from "../../components/layout/BreadCrumbs";
import dayjs from "dayjs";
import {
  useFetchActionQuery,
  useFetchProjectQuery,
  useFetchUsersForFieldQuery,
} from "../../features/api/apiSlice";

const PageProjectActionEdit: React.FC = () => {
  const { projectId, id } = useParams<{ id: string; projectId: string }>();

  const { data: action, isFetching: isFecthingAction } = useFetchActionQuery(
    id,
    {
      skip: !id,
    },
  );

  const { data: project, isFetching: isFetchingProject } = useFetchProjectQuery(
    Number(projectId),
    {
      skip: !projectId,
    },
  );

  const { data: dataPerformers, isFetching: isFetchingPorformers } =
    useFetchUsersForFieldQuery("");

  const { onSubmit, isLoading, isPostingAttachments } = useCrudAction(
    undefined,
    undefined,
    Number(projectId),
    true,
    action,
    "project",
  );

  const defaultValues: SchemaFormAction = useMemo(() => {
    if (!action) {
      return {
        eventType: "PROJECT",
        dateAsked: dayjs(),
        date: dayjs(),
        causeType: "CORRECTIF",
        title: "",
        description: "",
        effacity: "",
        pilote: "",
        performer: "",
        event: String(projectId),
      };
    }
    return {
      eventType: "PROJECT",
      dateAsked: dayjs(action.dateAsked),
      date: dayjs(action.date),
      causeType: action.causeType,
      title: action.title || "",
      description: action.description || "",
      effacity: action.effacity || "",
      pilote: action.pilote || "",
      performer: String(action.performer?.id),
      event: String(projectId),
    };
  }, [action, projectId]);

  const isPageLoading =
    isFecthingAction ||
    isFetchingProject ||
    isFetchingPorformers ||
    isPostingAttachments;

  return (
    <PageLayout pageContainerClassName={styles.root} isLoading={isPageLoading}>
      <Breadcrumbs
        pageName="projectAction"
        actionName={action?.title}
        actionId={Number(id)}
        eventName={project?.name}
        eventId={Number(projectId)}
      />
      {!isPageLoading && (
        <FormActions
          isEditMode
          onSubmit={onSubmit}
          isLoading={isLoading || isPostingAttachments}
          defaultValues={defaultValues}
          performers={dataPerformers || []}
        />
      )}
    </PageLayout>
  );
};

export default PageProjectActionEdit;
